<div class="card">
  <div class="card-header card-header-danger">
    <h4 class="card-title">Worst Technical Pages</h4>
    <p class="card-category">Prioritize these fixes urgently</p>
  </div>
  <div class="card-body">
    <div class="list-group list-group-flush">
      <div 
        *ngFor="let page of pages" 
        (click)="selectPage(page)"
        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center cursor-pointer"
        style="padding: 12px 0;"
      >
        <div class="text-truncate mr-2" style="max-width: 80%;" [title]="page.url">
          <i class="material-icons text-muted align-middle mr-1" style="font-size: 18px;">link</i>
          {{ page.urlPath || page.url }}
        </div>
        <span class="font-weight-bold" [ngClass]="getScoreColor(page.healthScore)">
          {{ page.healthScore }}
        </span>
      </div>
      <div *ngIf="pages.length === 0" class="text-center py-4 text-muted">
        No critical pages identified
      </div>
    </div>
  </div>
</div>
